import { z } from 'zod';

//--------------------------------
// Repository Object Schema
//--------------------------------
const repositoryObjectSchema = z.object({
    id: z.string(),
    dateCreated: z.number(),
    dateUpdated: z.number(),
});
var RepositorySortDirection;
(function (RepositorySortDirection) {
    RepositorySortDirection["asc"] = "asc";
    RepositorySortDirection["desc"] = "desc";
})(RepositorySortDirection || (RepositorySortDirection = {}));

export { RepositorySortDirection, repositoryObjectSchema };
//# sourceMappingURL=Repository.js.map
